module.exports = __webpack_public_path__ + "img/aa.37362679.png";